import L from "leaflet"

export const convertObjectKeysToCamelCase = (obj) => {
  const result = {}
  for (const [key, value] of Object.entries(obj)) {
    const camelKey = snakeToCamel(key)

    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      result[camelKey] = convertObjectKeysToCamelCase(value)
    } else if (Array.isArray(value)) {
      result[camelKey] = value?.map((item) =>
        typeof item === "object" && item !== null
          ? convertObjectKeysToCamelCase(item)
          : item,
      )
    } else {
      result[camelKey] = value
    }
  }
  return result
}
const snakeToCamel = (str) => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}
export const convertObjectKeysToSnakeCase = (obj) => {
  const result = {}
  for (const [key, value] of Object.entries(obj)) {
    const snakeKey = camelToSnake(key)

    if (
      value !== null &&
      typeof value === "object" &&
      value instanceof Date === false &&
      !Array.isArray(value)
    ) {
      result[snakeKey] = convertObjectKeysToSnakeCase(value)
    } else if (Array.isArray(value)) {
      result[snakeKey] = value?.map((item) =>
        typeof item === "object" && item !== null
          ? convertObjectKeysToSnakeCase(item)
          : item,
      )
    } else {
      result[snakeKey] = value
    }
  }
  return result
}

const camelToSnake = (str) => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

// Extract { lat, lon } from a GeographicalInformation's GeoJSON Point Feature.
// GeoJSON stores coordinates as [longitude, latitude]. Returns null when no valid point is set.
export const geoJsonToLatLon = (geo) => {
  const coordinates = geo?.geo_json?.geometry?.coordinates
  if (!Array.isArray(coordinates) || coordinates.length < 2) {
    return null
  }
  return { lat: coordinates[1], lon: coordinates[0] }
}

// Build the GeoJSON Point Feature the backend expects (inverse of geoJsonToLatLon).
// Delegates to Leaflet, which emits RFC 7946 [longitude, latitude] coordinates.
export const latLonToGeoJsonPoint = (lat, lon) =>
  L.marker([Number(lat), Number(lon)]).toGeoJSON()

const BOUNDS = {
  lat: [-90, 90],
  lon: [-180, 180],
}

export const isValidCoordinate = (value, type) => {
  if (value === null || value === undefined) return false
  const number = Number(value)
  if (!Number.isFinite(number)) return false
  const bounds = BOUNDS[type]
  if (!bounds) return true
  return number >= bounds[0] && number <= bounds[1]
}

export const formatCoordinate = (value, type) => {
  if (!isValidCoordinate(value, type)) return null
  return Number(Number(value).toFixed(5))
}

export const parseGeoLocation = (geo) => {
  const location = geoJsonToLatLon(geo)
  if (!location) return null
  const lat = formatCoordinate(location.lat, "lat")
  const lon = formatCoordinate(location.lon, "lon")
  if (lat === null || lon === null) return null
  return [lat, lon]
}

export const hasCoordinates = (location) =>
  Boolean(
    location &&
      isValidCoordinate(location.lat, "lat") &&
      isValidCoordinate(location.lon, "lon"),
  )

export const locationToPoints = (location) =>
  hasCoordinates(location) ? `${location.lat},${location.lon}` : null
